var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"product"}},[_c('div',{staticClass:"scan-detail"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),(_vm.compshow)?_c(_vm.currentTabComponent.components,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }